import React from "react";
import classNames from "classnames";
import { LatestCarousel } from "components/latestCarousel/latestCarousel";
import HomePageSectionHeader from "components/homePageSectionHeader/homePageSectionHeader";
import type { LatestItemCMS } from "lib/types/homepage";

export type LatestSectionContentProps = {
  headerTitle?: string;
  headerCtaText?: string;
  headerCtaUrl?: string;
  items: LatestItemCMS[];
  "data-testid"?: string;
};

export const LatestSectionContent: React.FC<LatestSectionContentProps> = ({
  headerTitle,
  headerCtaText,
  headerCtaUrl,
  items,
  "data-testid": dataTestId,
}) => {
  return (
    <div
      className="mx-auto w-full max-w-content-mobile px-5 md:max-w-content lg:max-w-container lg:px-0 mdDesktop:max-w-container mdDesktop:px-5"
      data-testid={dataTestId || "latest-section"}
    >
      {/* Section Header */}
      <HomePageSectionHeader
        title={headerTitle}
        buttonText={headerCtaText}
        buttonUrl={headerCtaUrl}
        theme="default"
        className="mb-4"
      />

      {/* Carousel */}
      <LatestCarousel items={items} />
    </div>
  );
};

export type LatestSectionProps = LatestSectionContentProps & {
  className?: string;
};

/**
 * LatestSection - Homepage section displaying latest items in a custom carousel
 *
 * Features:
 * - One large active card
 * - Up to 5 smaller preview cards on the right
 * - Section header with optional CTA link
 * - Prev/Next navigation buttons
 */
export const LatestSection: React.FC<LatestSectionProps> = ({
  className,
  "data-testid": dataTestId,
  ...contentProps
}) => {
  return (
    <section
      className={classNames("mb-16 bg-mono-05", className)}
      data-testid={dataTestId ? `${dataTestId}-wrapper` : undefined}
    >
      <LatestSectionContent {...contentProps} data-testid={dataTestId} />
    </section>
  );
};

export default LatestSection;
